module.exports = __webpack_public_path__ + "static/img/contact_logo7_h.f13070b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contact_logo7_h.png
// module id = Tk5x
// module chunks = 1